
import React from 'react';
import { X } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";

interface CommentTopicFilterProps {
  topics: string[];
  selectedTopics: string[];
  onSelectTopic: (topic: string) => void;
  onClearFilters: () => void;
}

const CommentTopicFilter: React.FC<CommentTopicFilterProps> = ({
  topics,
  selectedTopics,
  onSelectTopic,
  onClearFilters
}) => {
  if (topics.length === 0) return null;
  
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium">Filter by topics</h4>
        {selectedTopics.length > 0 && (
          <button 
            className="text-xs text-primary hover:underline flex items-center"
            onClick={onClearFilters}
          >
            <X className="h-3 w-3 mr-1" />
            Clear filters
          </button>
        )}
      </div>
      
      <ScrollArea className="max-w-full">
        <div className="flex flex-wrap gap-2 pb-1">
          {topics.map(topic => (
            <Badge
              key={topic}
              variant={selectedTopics.includes(topic) ? "default" : "outline"}
              className="cursor-pointer"
              onClick={() => onSelectTopic(topic)}
            >
              {topic}
            </Badge>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default CommentTopicFilter;
